'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandablePanel = require('./components/ExpandablePanel.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpandablePanel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-panel/index.js
// module id = 1411
// module chunks = 1